import type { AssistantCredits } from '../../types/api';
import { CREDITS_EXPLAINER, creditsMeterText, isCreditsLow } from './assistantCredits';

interface AssistantCreditsMeterProps {
  credits: AssistantCredits | null;
  /**
   * Both keep the explainer in a tooltip and for screen readers; the full page
   * also prints it where there is no hover to show a tooltip (touch).
   */
  variant: 'panel' | 'page';
}

/**
 * This month's assistant credits, "142 of 200 credits": muted, amber under
 * 10% left. Separate from the post quota in the header. Nothing renders while
 * the count is unknown (an older server, or before the first read).
 */
export function AssistantCreditsMeter({ credits, variant }: AssistantCreditsMeterProps) {
  if (credits === null) return null;
  const isLow = isCreditsLow(credits);
  return (
    <span
      className={[
        'assistant-credits',
        `assistant-credits--${variant}`,
        isLow ? 'assistant-credits--low' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      title={CREDITS_EXPLAINER}
    >
      <span className="assistant-credits__count">{creditsMeterText(credits)}</span>
      <span className="assistant-credits__explainer">{CREDITS_EXPLAINER}</span>
    </span>
  );
}
